import React,{Component} from  'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {EmptyDay} from './../planning/Day';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

class ResourceCalendarLine extends Component{

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const plansDifferent = JSON.stringify(this.props.plans) !== JSON.stringify(nextProps.plans);
        const daysDifferent = this.props.days[0] !== nextProps.days[0] ||
            this.props.days.length !== nextProps.days.length;

        return plansDifferent || daysDifferent;
    }

    render(){
        const props = this.props;
        const unit = props.unit;
        const granularity = props.granularity;
        const days = props.days;
        const dayWidth = props.dayWidth;
        const plans = props.plans;

        const grid = days.map((d,i) => {
            return <EmptyDay key={i} size={dayWidth} highlight={false}/>;
        });
        const hourGrid = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24].map((d,i) => {
            return <EmptyDay key={i} size={dayWidth} highlight={false}/>;
        });


        return (
            <div className="row" onClick={props.onClick || null}>
                <div className='plans'>
                    {granularity === 'hour' ? <PlanComponentsHour startTime={props.startTime} plans={plans} dayWidth={dayWidth} /> : <PlanComponents startTime={props.startTime} plans={props.plans} dayWidth={dayWidth} />}
                </div>
                <div className='cell-grid'>
                    {granularity === 'hour' ? hourGrid : grid}
                </div>
                <div className='name'>{unit.name}</div>
            </div>
        );
    };
}

ResourceCalendarLine.propTypes = {
    unit: PropTypes.object.isRequired,
    granularity: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    plans: PropTypes.array,
    startTime: PropTypes.any.isRequired
};

const PlanComponentsHour = props => {
    const start = moment(props.startTime);
    const dayWidth = props.dayWidth;
    return props.plans.map((p,i) => {
        let planStart = moment(p.startTime);
        if(planStart.isBefore(start)) planStart = start;
        const startTime = planStart.diff(props.startTime, 'minutes') / 60 * dayWidth;
        const duration = moment(p.endTime).diff(planStart, 'minutes') / 60;
        return <Plan key={p.id || i} dayWidth={dayWidth} startTime={startTime} duration={duration} p={p} />;
    })
};

PlanComponentsHour.propTypes = {
    startTime: PropTypes.any,
    plans: PropTypes.array,
    dayWidth: PropTypes.number
};

const PlanComponents = props => {
    const start = moment(props.startTime);
    const dayWidth = props.dayWidth;

    return props.plans.map((p,i) => {
        let planStart = moment(p.startTime);
        let planEnd = moment(p.endTime);
        
        // Clamp plan to visible calendar bounds
        if(planStart.isBefore(start)) planStart = start.clone();
        
        // Calculate precise positioning based on actual time within days
        const startTimeInDays = (planStart - start) / _MS_PER_DAY;
        const endTimeInDays = (planEnd - start) / _MS_PER_DAY;
        
        const leftPosition = startTimeInDays * dayWidth;
        const widthInDays = endTimeInDays - startTimeInDays;
        
        return <Plan key={p.id} dayWidth={dayWidth} startTime={leftPosition} duration={widthInDays} p={p} />;
    });
};

const Plan = props => {
    const duration = props.duration;
    const startTime = props.startTime;
    const p = props.p;
    const dayWidth = props.dayWidth;

    let label = "";
    if (p.person !== null) {
        label = label + p.person.name;
    }
    if (p.team !== null) {
        label = label + (p.person !== null ? " - " : "") + p.team.name;
    }

    if(duration > 0){
        return(
            <div key={p.id} className='plan' style={{left: `${startTime}%`, backgroundColor: 'red', width: `${duration * dayWidth}%`}}>
                <div className='plan-text'>
                    {label}
                </div>
            </div>
        )
    }
    return null;
};

Plan.propTypes = {
    startTime: PropTypes.number,
    duration: PropTypes.number,
    dayWidth: PropTypes.number,
    p: PropTypes.object,
};

PlanComponents.propTypes = {
    startTime: PropTypes.any,
    plans: PropTypes.array,
    dayWidth: PropTypes.number
};

export default ResourceCalendarLine;